var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-page-container"},[_c('div',{staticClass:"dashboard-page-content",class:( _obj = {'content-no-top':_vm.noTopSpace}, _obj[_vm.contentClass] = !!_vm.contentClass, _obj ),style:({
        'padding-top': (_vm.topPadding + "px")
    }),attrs:{"id":_vm.contentId}},[_vm._t("default"),_c('portal-target',{attrs:{"name":"iqos-tooltip-portal"}})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }